import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { GlobalService } from './global.service';
import { LogAcesso } from '../models/log-acesso';

@Injectable({
  providedIn: 'root',
})
export class LogTagAnexoService {
  constructor(private globalService: GlobalService, private http: HttpClient) {}

  consultarLogDeTagsDoPedido(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/LogTagAnexo/ListarLogsTagPedido',
      { params: new HttpParams().set('idCupom', idCupom) });
  }
}
